import { ReactNode } from 'react';

interface FormFieldProps {
  label: string;
  required?: boolean;
  optional?: boolean;
  error?: string;
  children: ReactNode;
  helpText?: string;
}

export default function FormField({
  label,
  required,
  optional,
  error,
  children,
  helpText
}: FormFieldProps) {
  return (
    <div className="space-y-1.5">
      <label className="block text-sm font-medium text-gray-900">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
        {optional && <span className="text-gray-400 ml-1">(optional)</span>}
      </label>
      <div className="relative">
        {children}
      </div>
      {helpText && (
        <p className="mt-1.5 text-sm text-gray-500">{helpText}</p>
      )}
      {error && (
        <p className="mt-1.5 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}